import React from "react"
import styled from "styled-components"
import { useTranslation } from "next-i18next"

interface UseCaseLayoutProps {
  content: any
}

export default function UseCaseLayout({ content }: UseCaseLayoutProps) {
  const { t } = useTranslation(["useCaseCommon"])

  return (
    <BG className={"open"}>
      <Wrapper className={`Wrapper`}>
        <ContentWrapper>{content}</ContentWrapper>
      </Wrapper>
    </BG>
  )
}

const BG = styled.div`
  position: fixed;
  background-color: #000000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: all 0.8s;
  &.open {
    width: 100%;
    height: 100%;
  }

  &.close {
    /* opacity: 0; */
    overflow: hidden;
    transform: translate(100%, 0%);
    .Wrapper {
      min-height: 0;
      overflow: hidden;
      opacity: 0;
    }
  }
`
const Wrapper = styled.div`
  transition: 0.3s;
  position: relative;
  width: 100%;
  height: 100%;
  /* border-radius: 16px; */
  background: #000;
  backdrop-filter: blur(100px);
  overflow: auto;
  z-index: 5;

  &.out {
    opacity: 0;
  }
`
const ContentWrapper = styled.div`
  position: absolute;
  top: 0;
  width: 100%;
`
